﻿window.dict_electricconnection_type_edit = function () {
    var instance = {
        init: function () {
            im.mask("#dict_electricconnection_type_edit_rows tr td input");
        },
        del: function (row) {
            row.closest("tr").remove();
        },
        add: function () {
            $("#dict_electricconnection_type_edit_rows").append('<tr><td class="r"><input name="plowerbound" type="text"></td><td class="r"><input name="pupperbound" type="text"></td><td class="r"><input name="k1" type="text"></td><td class="r"><input name="k2" type="text"></td><td><a onclick="dict_electricconnection_type_edit.del($(this))"><i class="icon icon-delete"></i></a></td></tr>');
            im.mask("#dict_electricconnection_type_edit_rows tr td input");
        }
    };
    var im = Inputmask("decimal", {
        radixPoint: '.',
        inputtype: "text",
        digits: 5
    });

    return instance;
}();